// URLPattern jest podstawą dopasowywania tras w @lit-labs/router.
// Polyfill jest tani i zdejmuje zależność od wersji przeglądarki.
import 'urlpattern-polyfill';

import './styles/tokens.css';
import './styles/reset.css';

import { waitForSession } from './core/auth.js';
import { applyTheme } from './core/ui.js';
import './components/qz-app.js';

// Motyw ustawia już skrypt w <head>; tutaj tylko domykamy stan store'a
// z tym, co faktycznie jest na dokumencie.
applyTheme();

// Startujemy odpytanie o sesję od razu. Strażnicy tras czekają na tę samą
// obietnicę, więc nikt nie zostanie odesłany na logowanie tylko dlatego,
// że odpowiedź jeszcze nie wróciła.
waitForSession();
